import classes from "./home.module.scss";

/**
 * The photo behind the home page and the login dialog. Anything shown to a logged-out user
 * gets it too, so logging out lands on the same picture as logging in - see App.tsx.
 */
const PageBackground = () => <div className={"d-print-none " + classes.homeBg}>&nbsp;</div>;

export default PageBackground;
